import store from '@/store';

import {axiosInstance, axios} from "@/api/modules/si-api-instance";

//PROCESSES
const getProcess_type = (data_source_id=null) => {
    let params_buffer = {}
    if(data_source_id!=null)
        params_buffer={data_source_id:data_source_id}

    return axiosInstance.get('config/process_type', {
        params:params_buffer
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getProcesses = () => {
    let organization_id =  store.getters['auth/org'];
    return axiosInstance.get('extract/processes', {
        params:{
            organization_id: organization_id
        },
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getProcess = (organization_id, id) => {
    return axiosInstance.get('extract/process', {
        params:{
            organization_id: organization_id,
            id: id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const postProcess = (organization_id, id, process) => {
    return axiosInstance.post('extract/process', {
        organization_id: organization_id,
        id: id,
        process:process
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

//SCHEDULERS
const putProcess = (organization_id, id, process) => {
    return axiosInstance.put('extract/process', {
        organization_id: organization_id,
        id: id,
        process: process
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getSchedulers = (organization_id,process_id) => {
    return axiosInstance.get('extract/schedulers', {
        params:{
            organization_id: organization_id,
            process_id: process_id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getSchedule = (organization_id, id) => {
    return axiosInstance.get('extract/schedule', {
        params:{
            organization_id: organization_id,
            id: id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const postSchedule = (organization_id, id, process_id, data_source_id, process_type_id, start_date, end_date, frequency, urls) => {
    return axiosInstance.post('extract/schedule', {
        organization_id: organization_id,
        id: id,
        process_id:process_id,
        data_source_id:data_source_id,
        process_type_id:process_type_id,
        start_date:start_date,
        end_date:end_date,
        frequency:frequency,
        urls:urls
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const putSchedule = (organization_id, id, process_id, data_source_id, process_type_id, start_date, end_date, frequency, urls) => {
    return axiosInstance.put('extract/schedule', {
        organization_id: organization_id,
        id: id,
        process_id:process_id,
        data_source_id:data_source_id,
        process_type_id:process_type_id,
        start_date:start_date,
        end_date:end_date,
        frequency:frequency,
        urls:urls
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const putRunSchedule = (organization_id, id) => {
    return axiosInstance.put('extract/schedule_run', {
        organization_id: organization_id,
        id: id
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

//WORDS
const getWords = (organization_id, schedule_id) => {
    return axiosInstance.get('extract/words', {
        params:{
            organization_id: organization_id,
            schedule_id: schedule_id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}


const postWord = (organization_id, process_id, schedule_id, word, word_type_id) => {
    return axiosInstance.post('extract/word', {
        organization_id: organization_id,
        process_id:process_id,
        schedule_id:schedule_id,
        word: word,
        word_type_id: word_type_id
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const postWords = (arreglo) => {
    return axios.all(arreglo)
    .then(()=>{
      console.log("asd");
    })
}

const deleteWord = (organization_id, schedule_id, word_id) => {
    return axiosInstance.delete('extract/word', {
        data:{
            organization_id: organization_id,
            schedule_id:schedule_id,
            word_id: word_id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getWorldData = () => {
    return axiosInstance.get('getWorldData')
      .then(function (response) {
          return response.data;
      })
      .catch(function (error) {
          return error;
      });
}
const getOrigenesByCity = (process_id,sentiment_type=null) => {
    return axiosInstance.get('getOrigenesByCity', {
        params:{
          process_id:process_id,
          sentiment_type:sentiment_type,
        }
      })
      .then(function (response) {
          return response.data;
      })
      .catch(function (error) {
          return error;
      });
}

const getAllElements = (process_id=null, page=1, page_size=20) => {
    let organization_id =  store.getters['auth/org'];
    return axiosInstance.get('/allElements', {
        params:{
            organization_id: organization_id,
            process_id : process_id,
            page : page,
            page_size : page_size
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

const getAllElementsCounts = (process_id=null) => {
    return axiosInstance.get('/allElementCounts', {
        params:{
            process_id : process_id
        }
    })
    .then(function (response) {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

export default {
    getProcess_type,
    getProcesses,
    getProcess,
    postProcess,
    putProcess,
    getSchedulers,
    getSchedule,
    getWords,
    postWord,
    deleteWord,
    postSchedule,
    putSchedule,
    putRunSchedule,
    getWorldData,
    getOrigenesByCity,
    getAllElements,
    getAllElementsCounts,
    postWords
};
